import React, { useState } from "react";
import PageHeader from "../layout/PageHeader";
import { SlCalender } from "react-icons/sl";
import { FaCommentDots } from "react-icons/fa";

const content = [
  {
    img: "/image/blog-section/blog-1.jpg",
    title: "How Exchange Rate Effect Your Business Growth",
    badge: "Corporate",
  },
  {
    img: "/image/blog-section/blog-2.jpg",
    title: "How To Stop Currency From Being Overwhelmed",
    badge: "Consumer",
  },
  {
    img: "/image/blog-section/blog-3.jpg",
    title: "How To Transfer Money With International Debit Card",
    badge: "Finance",
  },
  {
    img: "/image/blog-section/blog-4.jpg",
    title: "How To Stop Currency From Being Overwhelmed",
    badge: "Consumer",
  },
  {
    img: "/image/blog-section/blog-5.jpg",
    title: "Effect Of Inflation On Our Daily Expenditure",
    badge: "Finance",
  },
  {
    img: "/image/blog-section/blog-6.jpg",
    title: "7 Tips To Get Best Exchange Rate In Currency",
    badge: "Finance",
  },
];

const Blog = () => {
  const [blogs, setBlogs] = useState(content);
  const [inputData, setInputData] = useState(" ");

  const storeValue = (value) => {
    setInputData(value);
    const newBlog = content.filter((element) => {
      return element.title.toLowerCase().includes(value.toLowerCase());
    });

    setBlogs(newBlog);
  };

  return (
    <div className="blog_page">
      <PageHeader title="Blog Page" crumb="Blog" />
      <div className="container px-sm-2 px-4 section-padding">
        {/* CONTENT SECTION */}
        <div className="row padding-bottom">
          <div className="col-12 d-flex justify-content-end">
            <button className="blog_search d-flex align-items-center gap-3 shadow-sm">
              <input
                type="text"
                className="form-control p-3 rounded-0"
                placeholder="Search blog..."
                value={inputData}
                onChange={(event) => storeValue(event.target.value)}
              />
              <span className="search_icon">
                <i className="fa-solid fa-magnifying-glass"></i>
              </span>
            </button>
          </div>
        </div>
          {/* BLOG CONTENT SECTION */}
        <div className="row g-4">
          {blogs.map((element, index) => {
            return (
              <div className="col-lg-4 col-sm-6" key={index} data-aos="fade-up">
                <div className=" p-4 blog_card transition index-1 position-relative  bg-white rounded-4 shadow-sm overflow-hidden">
                  <div className="blog_img overflow-hidden rounded-4 position-relative">
                    <img
                      src={element.img}
                      className="img-fluid rounded-4 transition"
                      alt=""
                    />
                    <div className="badge">{element.badge}</div>
                  </div>
                  <div className="blog_body ">
                    {/* DATE SECTION */}
                    <ul className="list-unstyled d-flex gap-4 mt-2">
                      <li className="mb-2">
                        <span className="mb-0 me-2 text-green date">
                          <SlCalender />
                        </span>{" "}
                        <span className="mb-0 text-color date">
                          May 22 , 2022
                        </span>
                      </li>
                      <li className="mb-2">
                        <span className="mb-0 me-2 text-green date">
                          <FaCommentDots />
                        </span>{" "}
                        <span className=" date mb-0 text-color">
                          May 22 , 2022
                        </span>
                      </li>
                    </ul>
                    {/* TITLE SECTION */}
                    <h5 className="text-black fw-800 transition blog_title">
                      {element.title}
                    </h5>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

          <div className="row padding-top">
            <div className="col-lg-6 mx-auto">
              <ul className="pagination d-flex gap-4 align-items-center justify-content-center">
                <li className="pagination_item shadow-sm"><i className="fa-solid fa-arrow-left"></i></li>
                <li className="pagination_item active shadow-sm">1</li>
                <li className="pagination_item shadow-sm">2</li>
                <li className="pagination_item shadow-sm">3</li>
                <li className="pagination_item shadow-sm"><i class="fa-solid fa-arrow-right"></i></li>
              </ul>
            </div>
          </div>

      </div>
    </div>
  );
};

export default Blog;
